import React, { useState, useCallback, forwardRef, useEffect, useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import * as THREE from 'three'

const dracoLoader = new DRACOLoader();
dracoLoader.setDecoderPath('/draco/');

const VideoModel = forwardRef(({ 
  videoButtonColor, 
  hoverColor, 
  stationVisible, 
  data,
  setVideoSrc,
  onLoad,
  ...props 
}, ref) => {
  const { nodes, materials } = useGLTF('/models/Seperated/23_09_video-button-transformed.glb', true, true, (loader) => {
    loader.setDRACOLoader(dracoLoader);
  });
  const [isHovering, setIsHovering] = useState(false)
  const groupRef = useRef()
  const outerMeshRef = useRef()
  const innerMeshRef = useRef()

  useEffect(() => {
    if (onLoad) onLoad();
  }, [onLoad]);

  useFrame(() => {
    if (outerMeshRef.current && innerMeshRef.current) {
      const outerTargetColor = isHovering ? new THREE.Color('white') : new THREE.Color(videoButtonColor)
      const innerTargetColor = isHovering ? new THREE.Color(videoButtonColor) : new THREE.Color('white')
      
      outerMeshRef.current.material.color.lerp(outerTargetColor, 0.1)
      innerMeshRef.current.material.color.lerp(innerTargetColor, 0.1)
    }
  })

  const handleVideoPlay = useCallback(async () => {
    const videoUrl = `https://pfizer-vwt.s3-accelerate.amazonaws.com/assets/Booth_${stationVisible + 1}/video.mp4`;
    setVideoSrc({ url: videoUrl, autoplay: true });
    await logAction('click', 'video');
  }, [stationVisible, setVideoSrc]);

  const logAction = async (action, value) => {
    const email = localStorage.getItem('userEmail');
    const stationName = data.stations[stationVisible].title;
    const apiUrl = `https://vwt-api.pfizer-qr.com/api/?e=${encodeURIComponent(email)}&c=website&a=${action}&l=${encodeURIComponent(stationName)}&v=${value}`;
    try {
      const response = await fetch(apiUrl);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      console.log(`${action} action logged successfully`);
    } catch (error) {
      console.error(`Error logging ${action} action:`, error);
    }
  };

  return (
    <group 
      {...props} 
      ref={groupRef}
      onClick={handleVideoPlay}
      onPointerOver={() => {
        setIsHovering(true)
        document.body.style.cursor = 'pointer'
      }}
      onPointerOut={() => {
        setIsHovering(false)
        document.body.style.cursor = 'default'
      }}
    >
      <mesh 
        ref={outerMeshRef}
        geometry={nodes.Video_Buttons001.geometry} 
        material={materials['Video buttons white']}
      >
        <meshStandardMaterial color={videoButtonColor} />
      </mesh>
      <mesh 
        ref={innerMeshRef}
        geometry={nodes.Video_Buttons001_1.geometry} 
        material={materials['Video buttons white']}
      >
        <meshStandardMaterial color="white" />
      </mesh>
    </group>
  )
})

useGLTF.preload('/23_09_video-button-transformed.glb')

export default VideoModel